module.exports = __webpack_public_path__ + "static/media/slider_bg_mob_1.1e725d91.jpg";